import type { FaireProductEntity } from "../../entity_types/product";

export const p_pbvthdvwp7: FaireProductEntity = {
  token: "p_pbvthdvwp7",
  type: "product",
  name: "`.Colorful Portable Mini Humidifier Essential Oil Diffuser",
  brandToken: "b_849n5pbfjm",
  brandName: "42POPS",
  imageUrl:
    "https://cdn.faire.com/fastly/393638ec6037dc77dd4ffb80bc2c700e3425795021c48b6fac7b5bbb9b45a1b3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/33bb3f721ed971aca82391997dce44331a281fe10d70ff68e704b8719a8945a5.jpeg",
    "https://cdn.faire.com/fastly/5ce4dc2366753fd36f9be45678a142b2de679704d76e9631cade999c9dccd738.jpeg",
    "https://cdn.faire.com/fastly/d2cd48f59b03e14270ed5f66d14095f31d02c6ee8363d3e92c44f0003702d2fe.jpeg",
    "https://cdn.faire.com/fastly/be76636e188915086f47d2eb51995ee9006a5718ad1dcb2fa7b70ccf2e440095.jpeg",
    "https://cdn.faire.com/fastly/b035557aefc7e8c16605ad2c666c0c458fcd501bd28daaeeeb74bfc7b80705e3.jpeg",
    "https://cdn.faire.com/fastly/b082a637b085086c47f435a96dc009a43054a9b6285f9743ad69db6a773495cf.jpeg",
  ],
  priceDollars: 6,
  description:
    '***Image usage is allowed to the buyers who purchase from us via Faire only.\nSI-25439 Colorful Portable Mini Humidifier Essential Oil Diffuser\n- RECHARGEABLE BATTERY (USB)\n- HEIGHT: 4.7", WIDTH: 3"\n- WEIGHT: 3.7OZ\n- PC+ABS MATERIAL\n- MAX CAPACITY 300ML\n- HIGH QUALITY ATOMIZATION\n- COLORFUL AMBIENCE LIGHTING\n- AUTO SHUT OFF\n*WHAT&rsquo;S INCLUDED: DEVICE, CHARGING CABLE, COTTON SWAB\n**COLOR MAY VARY SLIGHTLY DUE TO MONITOR RESOLUTION\nMaterial:\nAnchorBestseller\n\nSI-25439 Colorful Portable Mini Humidifier Essential Oil Diffuser ()\nGREY-161283\nPINK-161284\nWHITE-161297\n',
  tags: [],
  msrpDollars: 15,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:38.697Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
